import React, { Fragment, useEffect, useRef, useState } from "react";

import {
  Autocomplete,
  Backdrop,
  Box,
  Collapse,
  createTheme,
  CssBaseline,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Skeleton,
  TextField,
  ThemeProvider,
} from "@mui/material";
import Loader from "../../../components/Loader";
import { toast, ToastContainer } from "react-toastify";
import { common_axios } from "../../../App";
import { useFormik } from "formik";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import SearchIcon from "@mui/icons-material/Search";
import CancelIcon from "@mui/icons-material/Cancel";
import index from "../../login";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

export default function ShyamLala() {
  function not(a, b) {
    return a.filter((value) => b.indexOf(value) === -1);
  }

  function intersection(a, b) {
    return a.filter((list) => b.indexOf(list) !== -1);
  }

  function union(a, b) {
    return [...a, ...not(b, a)];
  }

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const [open, setOpen] = React.useState(false);

  const [checked, setChecked] = React.useState([]);
  const [checked1, setChecked1] = React.useState([]);

  const [left, setLeft] = React.useState([]);

  const [right, setRight] = React.useState([]);

  const [reset, setReset] = React.useState([]);

  const [showSearchBar, setshowSearchBar] = React.useState(true);

  const [rolesList, setRolesList] = useState([]);

  const [roles1, setRoles1] = useState(null);

  const leftChecked = intersection(checked, left);

  const rightChecked = intersection(checked, right);

  const handleToggle = (list) => () => {
    const currentIndex = checked.indexOf(list);

    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(list);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
    console.log({ newChecked });
    // setChecked1(newChecked[0].subMenuDetails);
  };

  // const handleTogglee = (listt, id, subId) => () => {
  //   let newChecked = [...checked];

  //   var menuIndex = newChecked.findIndex(function (menu) {
  //     return menu.id == id;
  //   });

  //   console.log(menuIndex);

  //   // newChecked[newChecked].subMenuDetails;

  //   const filteredSubMenu = newChecked[menuIndex]?.subMenuDetails?.filter(
  //     (subbb) => subbb.id != subId
  //   );

  //   newChecked[menuIndex].subMenuDetails = newChecked[
  //     menuIndex
  //   ].subMenuDetails.filter((subbb) => subbb.id != subId);

  //   console.log(
  //     { listt, id, subId, newChecked, filteredSubMenu },
  //     newChecked[menuIndex].subMenuDetails
  //   );

  //   // setChecked1(newChecked[0].subMenuDetails);
  //   setChecked1([]);
  // };

  const numberOfChecked = (items) => intersection(checked, items).length;

  const handleToggleAll = (items) => () => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  const handleAllInLeft = () => {
    setLeft(reset);
    setRight([]);
    setChecked(not(checked, rightChecked));
  };

  // useEffect(() => {
  //   if (roles1) {
  //     const filterRole = rolesList.filter((el) => {
  //       return roles1.name == el.name;
  //     });

  //     // setLeft(filterRole[0].menuDetails);
  //     setReset(filterRole[0].menuDetails);
  //     setLeft(roles1[0]?.menuDetails.subMenuDetails);
  //     // setReset(roles1[0]?.menuDetails);
  //   }
  // }, [roles1]);

  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
  });

  const saveSubMenu = async () => {
    try {
      setOpen(true);
      const res = await common_axios.post(`admin/v1/sub-menu/create`, {
        subMenu: checked.map((checked) => checked.subMenu),
        menuId: checked.map((checked) => checked.id),
        roleId: roles1.id,
        status: false,
      });

      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        setRight([]);
        setRoles1([]);
        setLeft(roles1.menuDetails);

        setshowSearchBar(true);
        await toast.success("Sub menu saved successfully", {
          theme: "colored",
        });
      } else {
        setOpen(false);
        await toast.error(res.data.statusDescription.description, {
          theme: "colored",
        });
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      await toast.error("Something went wrong!! Please try again later", {
        theme: "colored",
      });
    }
  };

  const saveRole = async (value, index) => {
    try {
      console.log({ index });
      setOpen(true);
      const res = await common_axios.post(`admin/role/v1/add/menu`, {
        menu: right.map((right) => right.menu).toString(),
        roleId: roles1.id,
        status: false,
      });

      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        setRight([]);
        setRoles1([]);
        setLeft(roles1.menuDetails);

        setshowSearchBar(true);
        await toast.success("Saved Successfully", {
          theme: "colored",
        });
      } else {
        setOpen(false);
        await toast.error(res.data.statusDescription.description, {
          theme: "colored",
        });
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      await toast.error("Something went wrong!! Please try again later", {
        theme: "colored",
      });
    }
  };

  const customList = (title, items) => (
    <Card>
      <CardHeader
        sx={{ px: 2, py: 1 }}
        avatar={
          <Checkbox
            onClick={() => {
              console.log(items);
              handleToggleAll(items);
              // handleToggleAllSubMenu(items);
            }}
            checked={
              numberOfChecked(items) === items?.length && items?.length !== 0
            }
            indeterminate={
              numberOfChecked(items) !== items?.length &&
              numberOfChecked(items) !== 0
            }
            disabled={items?.length === 0}
            inputProps={{
              "aria-label": "all items selected",
            }}
          />
        }
        title={title}
        subheader={`${numberOfChecked(items)}/${items?.length} selected`}
      />
      <Divider />
      <List
        sx={{
          // width: 200,
          height: 300,
          bgcolor: "background.paper",
          overflow: "auto",
        }}
        dense
        component="div"
        role="list"
      >
        {items?.map((value) => {
          const labelId = `transfer-list-all-item-${value}-label`;

          return (
            <>
              <ListItem
                key={value.id}
                role="listitem"
                className="ms-0"
                button
                // onClick={handleToggle(value)}
              >
                {/* <ListItemIcon>
                  <Checkbox
                    checked={checked.indexOf(value) !== -1}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{
                      "aria-labelledby": labelId,
                    }}
                  />
                </ListItemIcon> */}
                <ListItemText id={labelId} primary={value.menu} />
              </ListItem>
              {value?.subMenuDetails?.map((list) => {
                return (
                  <ListItem
                    key={list.id}
                    className="ms-3"
                    role="listitem"
                    button
                    onClick={handleToggle(list)}
                  >
                    <ListItemIcon>
                      <Checkbox
                        checked={checked.indexOf(list) !== -1}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{
                          "aria-labelledby": labelId,
                        }}
                      />
                    </ListItemIcon>
                    <ListItemText id={labelId} primary={list.subMenu} />
                  </ListItem>
                );
              })}
            </>
          );
        })}
      </List>
    </Card>
  );

  const getRoles = async () => {
    try {
      setOpen(true);
      const res = await common_axios(`admin/v1/roles/list?roleId=1`);
      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        setRolesList(res.data.role.menuDetails);
        setLeft(res.data.role.menuDetails);
      } else {
        setOpen(false);
        await toast.error(res.data.statusDescription.description, {
          theme: "colored",
        });
      }
    } catch (error) {
      setOpen(false);
      await toast.error("Something went wrong !! Please check your network", {
        theme: "colored",
      });
    }
  };

  React.useEffect(async () => {
    await getRoles();
    // await fetchApi();
  }, []);

  // const fetchApi = async () => {
  //   const res = await fetch("https://jsonplaceholder.typicode.com/users");
  //   const data = await res.json();
  // };
  // React.useEffect(() => {}, []);

  // const formik = useFormik({
  //   initialValues: {
  //     messageTypeName: "",
  //     channelId: null,
  //   },

  //   onReset: (initialValues) => ({
  //     values: { initialValues },
  //   }),
  //   validateOnChange: true,

  //   // validationSchema: validationSchema,

  //   onSubmit: async (values) => {},
  // });
  const addUsermodal = () => {
    modalAddUser.current.click();
  };
  console.log({ roles1 });
  const modalAddUser = useRef(null);
  const modalAddUserClose = useRef(null);
  return (
    <div className="container-fluid">
      <Backdrop
        sx={{
          transform: "translateZ(0)",
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={open}
      >
        <Loader />
      </Backdrop>
      <ToastContainer autoClose={6000} />

      <div>
        <button
          ref={modalAddUser}
          type="button"
          className="btn btn-primary d-none"
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop1"
        >
          Launch static backdrop modal
        </button>

        <div
          className="modal fade"
          id="staticBackdrop1"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdrop1Label"
          aria-hidden="true"
        >
          <form>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdrop1Label">
                    New Role
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>

                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6">
                      <label for="exampleInputEmail1" className="form-label">
                        Role Name:
                      </label>
                      <input
                        // disabled
                        type="text"
                        required
                        // value={selectUserDetailsBlock?.username}
                        className="form-control"
                        id="exampleInputEmail1"
                        placeholder="Role Name Here"
                        aria-describedby="emailHelp"
                      />
                    </div>
                    <div className="col-md-6 mt_2">
                      <label for="exampleInputEmail1" className="form-label">
                        Menu :
                      </label>
                      <input
                        // disabled
                        required
                        type="text"
                        placeholder="Menu Here"
                        // value={selectUserDetailsBlock?.email}
                        className="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-md-6">
                      <label for="exampleInputEmail1" className="form-label">
                        Sub-Menu:
                      </label>
                      <input
                        // disabled
                        type="text"
                        required
                        placeholder="Sub Menu Here"
                        // value={selectUserDetailsBlock?.mobile}
                        className="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                      />
                    </div>
                    {/* <div className="col-md-6">
                      <label for="exampleInputEmail1" className="form-label">
                        Rolename:
                      </label>
                      <input
                        // disabled
                        required
                        className="form-control"
                    
                        type="text"
                        minLength="3"
                        // value={selectUserDetailsBlock?.roleName}
                      />
                    </div> */}
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-bs-dismiss="modal"
                    ref={modalAddUserClose}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    class="btn btn-primary"
                    // data-bs-dismiss="modal"
                    // data-bs-dismiss="modal"
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="card mb-3 mt-4">
        <div class="card-header p-3 pt-2">
          <div class="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
            <i class="material-icons opacity-10">person</i>
            {/* <div>User Management</div> */}
          </div>
          <div
            class="d-flex justify-content-between pt-1"
            style={{ marginLeft: "76px" }}
          >
            <div className="fw-bold">Manage Roles</div>
          </div>
        </div>
        <ThemeProvider theme={theme}>
          <div class="card-body">
            <div className="card shadow-none border bg_blue">
              <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                Manage Roles
              </span>

              <div className="container">
                <div className="row">
                  <div className="col-md-3 ms-3 mt-3 mb-3">
                    <Autocomplete
                      disablePortal
                      size="small"
                      className="w-100"
                      id="combo-box-demo"
                      options={rolesList}
                      getOptionLabel={(option) => `${option.name}`}
                      name="roleType"
                      value={rolesList.id}
                      onChange={(e, value) => {
                        setRoles1(value);
                      }}
                      renderInput={(params) => (
                        <TextField
                          required
                          {...params}
                          label="Select Role Type"
                        />
                      )}
                    />
                  </div>

                  {showSearchBar == true ? (
                    <div className="text-end">
                      <button
                        type="submit"
                        disabled={roles1 == null}
                        // onClick={handleAllInLeft}
                        className={
                          roles1 != null
                            ? "btn btn-primary text-end me-3"
                            : "btn btn-secondary text-end me-3"
                        }
                        onClick={() => {
                          setLeft(roles1?.menuDetails);

                          setshowSearchBar(false);
                          // setRoles(value);
                        }}
                        // disabled={roles == null}
                      >
                        <SearchIcon />
                      </button>
                    </div>
                  ) : (
                    <div className="text-end">
                      <button
                        // onClick={handleAllInLeft}
                        // disabled={roles1 == null}
                        className="btn btn-primary text-end me-3"
                        onClick={() => {
                          // setLeft(roles1?.menuDetails);

                          setshowSearchBar(true);
                          setRight([]);
                          // setRoles(value);
                        }}
                        // disabled={roles == null}
                      >
                        <CancelIcon />
                      </button>
                    </div>
                  )}

                  <div className="col-md-6">
                    <button className="btn btn-primary" onClick={addUsermodal}>
                      Add New
                    </button>
                  </div>
                  <div className="border_btm"></div>
                  {showSearchBar != true ? (
                    <>
                      <div className="row">
                        <div className="w-100 text-start">
                          <Grid
                            container
                            spacing={2}
                            justifyContent="center"
                            alignItems="center"
                          >
                            <Grid md={5} item>
                              {customList("Avalaible", left)}
                            </Grid>
                            <Grid md={2} item>
                              <Grid
                                container
                                direction="column"
                                alignItems="center"
                              >
                                <Button
                                  sx={{ my: 0.5 }}
                                  variant="outlined"
                                  size="small"
                                  onClick={handleCheckedRight}
                                  disabled={leftChecked.length === 0}
                                  aria-label="move selected right"
                                >
                                  &gt;
                                </Button>
                                <Button
                                  sx={{ my: 0.5 }}
                                  variant="outlined"
                                  size="small"
                                  onClick={handleCheckedLeft}
                                  disabled={rightChecked.length === 0}
                                  aria-label="move selected left"
                                >
                                  &lt;
                                </Button>
                                <button
                                  className={
                                    right.length === 0
                                      ? "mt-1 btn btn-secondary"
                                      : "mt-1 btn btn-primary"
                                  }
                                  onClick={() => {
                                    setRight([]);
                                    // setRoles1([]);
                                    setLeft(roles1.menuDetails);
                                  }}
                                  disabled={right.length === 0}
                                >
                                  Reset
                                </button>
                              </Grid>
                            </Grid>
                            <Grid md={5} item>
                              {customList("Mapped", right)}
                            </Grid>
                          </Grid>
                        </div>
                      </div>
                      <div className="row">
                        <div className="text-end ">
                          <button
                            onClick={() => {
                              saveRole();
                              saveSubMenu();
                            }}
                            className={
                              right.length === 0
                                ? "btn btn-secondary text-end me-3"
                                : "btn btn-primary text-end me-3"
                            }
                            disabled={right.length === 0}
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </ThemeProvider>
      </div>
    </div>
  );
}
